import { combineEpics, type Epic } from 'redux-observable';
import {
  filter,
  from,
  mergeMap,
  map,
  catchError,
  ignoreElements,
  merge,
  of,
} from 'rxjs';
import {
  listFavorites,
  addFavorite,
  removeFavorite,
} from '@/api/istaff/property';
import {
  loadFavorites,
  addToFavorites,
  removeFromFavorites,
  setFavoriteIds,
  addFavoriteId,
  removeFavoriteId,
  setLoading,
} from '../actions';

const loadFavoritesEpic: Epic = (action$) =>
  action$.pipe(
    filter(loadFavorites.match),
    mergeMap(() =>
      merge(
        of(setLoading(true)),
        from(listFavorites({ perPage: 50 })).pipe(
          map((res) => setFavoriteIds(res.data.map((p) => p.id))),
          catchError(() => of(setLoading(false))),
        ),
      ),
    ),
  );

const addToFavoritesEpic: Epic = (action$) =>
  action$.pipe(
    filter(addToFavorites.match),
    mergeMap(({ payload: propertyId }) =>
      merge(
        of(addFavoriteId(propertyId)),
        from(addFavorite(propertyId)).pipe(
          ignoreElements(),
          catchError(() => of(removeFavoriteId(propertyId))),
        ),
      ),
    ),
  );

const removeFromFavoritesEpic: Epic = (action$) =>
  action$.pipe(
    filter(removeFromFavorites.match),
    mergeMap(({ payload: propertyId }) =>
      merge(
        of(removeFavoriteId(propertyId)),
        from(removeFavorite(propertyId)).pipe(
          ignoreElements(),
          catchError(() => of(addFavoriteId(propertyId))),
        ),
      ),
    ),
  );

export default combineEpics(
  loadFavoritesEpic,
  addToFavoritesEpic,
  removeFromFavoritesEpic,
);
